import axios from 'utils/axios';

export const getDeploymentRequests = async ({ pageNo = 1, perPage = 10, query = '', status = '' }) => {
    const response = await axios.get('deployment-requests', {
        params: { pageNo, perPage, query, status }
    });
    return response.data;
};

export const getDeploymentRequestsSummary = async () => {
    const response = await axios.get('deployment-requests/summary');
    return response.data;
};

export const createDeploymentRequest = async (data) => {
    const response = await axios.post('deployment-requests', data);
    return response.data;
};

export const updateDeploymentRequest = async (id, data) => {
    const response = await axios.patch(`deployment-requests/${id}`, data);
    return response.data;
};

export const approveDeploymentRequest = async (id) => {
    const response = await axios.patch(`deployment-requests/${id}/approve`);
    return response.data;
};

export const declineDeploymentRequest = async (id, declineNotes = '') => {
    const response = await axios.patch(`deployment-requests/${id}/decline`, { declineNotes });
    return response.data;
};

export const getDeploymentRequestLogo = async (id) => {
    const response = await axios.get(`deployment-requests/${id}/logo`);
    return response.data;
};

export const uploadDeploymentRequestLogo = async (id, formData) => {
    const response = await axios.put(`deployment-requests/${id}/logo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

export const removeDeploymentRequestLogo = async (id) => {
    const response = await axios.delete(`deployment-requests/${id}/logo`);
    return response.data;
};
